import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectWebsiteTheme } from '../../store/slices/website';

import CLCurrency from '../../components/CLCurrency';

import { Price } from './styled';

const ListingPrice = ({ listing, marginBottom, noBg }) => {
  const { colors } = useSelector(selectWebsiteTheme);

  if (!listing.rent_min && !listing.rent_max) {
    return null;
  }

  return (
    <Price
      noBg={noBg}
      color={colors[0].color}
      bgColor={colors[7].color}
      marginBottom={marginBottom}
    >
      <CLCurrency value={listing.rent_min} currency="USD" />
      {' - '}
      <CLCurrency value={listing.rent_max} currency="USD" />
    </Price>
  );
};

ListingPrice.propTypes = {
  listing: PropTypes.object.isRequired,
  marginBottom: PropTypes.string,
  noBg: PropTypes.bool,
};

ListingPrice.defaultProps = {
  marginBottom: '0',
  noBg: false,
};

export default ListingPrice;
